import React from 'react';
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import type { SubscriptionView } from '../api/generated/models/SubscriptionView';
import { helper } from '../utils/helper';
import { addNotification } from '../store/slices/notificationSlice';
import { useDispatch } from 'react-redux';

interface LicenseAwareLinkProps {
  pluginName: string;
  to: string;
  children: React.ReactNode;
  buyButton?: React.ReactNode;
  parentUserId?: string | null;
  // TODO: remove once google_review_manager license product is created in the backend
  skipLicenseCheck?: boolean;
}

export const LicenseAwareLink: React.FC<LicenseAwareLinkProps> = ({ 
  pluginName, 
  to, 
  children,
  buyButton = <button className="btn btn-primary">Buy</button>,
  parentUserId,
  skipLicenseCheck = false,
}) => {
  const { t } = useTranslation();
  const { items: subscriptions } = useSelector((state: RootState) => state.licenses);
  const dispatch = useDispatch();

  const hasValidSubscription = skipLicenseCheck || subscriptions.some(
    (subscription: SubscriptionView) => subscription.pluginName === pluginName
    && helper.isSubscriptionActive(subscription)
  );

  if (!hasValidSubscription) {
    if (parentUserId) {
      return (
        <span onClick={() => {
          dispatch(addNotification({
            type: 'warning',
            title: t('notification_warning'),
            message: t('notification_only_parent_user_can_buy_license'),
          }));
        }}>{buyButton}</span>
      );
    }
    return (
      <Link to={`/licenses/buy?plugin=${pluginName}`}>
        {buyButton}
      </Link>
    );
  }

  return <Link to={to}>{children}</Link>;
};
